import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AlertType = 'success' | 'error' | 'info' | 'warning';

export interface AlertState {
  open: boolean;
  message: string;
  type: AlertType;
  duration?: number; // ms, optional
}

const initialState: AlertState = {
  open: false,
  message: '',
  type: 'info',
  duration: 4000,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert: (state, action: PayloadAction<Omit<AlertState, 'open'>>) => {
      state.open = true;
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.duration = action.payload.duration ?? 4000;
    },
    hideAlert: (state) => {
      state.open = false;
      state.message = '';
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;
export default alertSlice.reducer; 